import type { HTMLAttributes } from "react";

import { cn } from "@/lib/helpers/cn";

export function ViewContent2({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("tw:contents", className)} {...props} />;
}
